module.exports = __webpack_public_path__ + "img/auto-invest.80981e17.svg";